<div class="split-login-container">
    <!-- Left Panel - Welcome Section -->
    <div class="welcome-panel">
        <div class="welcome-content">
            <!-- Logo Section -->
            <div class="logo-section">
                <img class="company-logo" src="../assets/public/images/banner_2.png" alt="CREDITOTAL" />
            </div>

            <!-- Welcome Message -->
            <div class="welcome-message">
                <h2 class="welcome-title">¡Nos alegra verte de nuevo!</h2>
                <h1 class="main-title">BIENVENIDO</h1>
                <p class="welcome-description">
                    Accede a tu plataforma de gestión financiera y continúa
                    brindando las mejores soluciones crediticias a tus clientes.
                </p>
            </div>
        </div>

        <!-- Decorative Elements -->
        <div class="floating-element element-1"></div>
        <div class="floating-element element-2"></div>
        <div class="floating-element element-3"></div>
        <div class="floating-element element-4"></div>
    </div>

    <!-- Right Panel - Login Form -->
    <div class="login-panel">
        <div class="login-form-container">

            <!-- Login Form Normal -->
            <div
                *ngIf="!showSelectMethod && !showVerify2FA && !showAccountLocked && !showSetup2FA && !showPasswordRecovery">
                <!-- Form Header -->
                <div class="form-header">
                    <h3 class="form-title">Iniciar Sesión</h3>
                    <p class="form-subtitle">Ingresa tus credenciales para acceder</p>
                </div>

                <!-- Success Messages -->
                <div *ngIf="successMessages?.length > 0" class="success-container" style="margin-bottom: 1.5rem;">
                    <div class="success-alert" *ngFor="let item of successMessages"
                        style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
                        <i class="fas fa-check-circle" style="color: #16a34a; margin-top: 0.125rem;"></i>
                        <span style="color: #166534; font-size: 0.875rem;">{{item?.msg}}</span>
                    </div>
                </div>

                <!-- Error Messages -->
                <div *ngIf="errors?.length > 0" class="error-container" style="margin-bottom: 1.5rem;">
                    <div class="error-alert" *ngFor="let item of errors"
                        style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
                        <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
                        <span style="color: #991b1b; font-size: 0.875rem;">{{item?.msg}}</span>
                    </div>
                </div>

                <!-- Login Form -->
                <form novalidate [formGroup]="form" (ngSubmit)="submit()" class="auth-form">

                    <!-- Username Field -->
                    <div class="input-group">
                        <label for="correo" class="input-label">Usuario</label>
                        <div class="input-wrapper">
                            <i class="fas fa-user input-icon"></i>
                            <input type="text" id="correo" formControlName="correo" class="auth-input"
                                [class.error]="form.controls.correo.invalid && form.controls.correo.dirty"
                                placeholder="Ingresa tu usuario" (keyup.enter)="onEnterKey()">
                        </div>
                        <div class="input-error" *ngIf="form.get('correo').errors && form.get('correo').dirty">
                            <i class="fas fa-exclamation-circle"></i>
                            <span *ngIf="form.get('correo').errors['required']">Campo requerido</span>
                        </div>
                    </div>

                    <!-- Password Field -->
                    <div class="input-group">
                        <label for="password" class="input-label">Contraseña</label>
                        <div class="input-wrapper">
                            <i class="fas fa-lock input-icon"></i>
                            <input [type]="typeInputPass ? 'text' : 'password'" id="password" formControlName="password"
                                class="auth-input"
                                [class.error]="form.controls.password.invalid && form.controls.password.dirty"
                                placeholder="Ingresa tu contraseña" (keyup.enter)="onEnterKey()">
                            <button type="button" class="password-visibility" (click)="typeInputPass = !typeInputPass">
                                <i class="fas" [class.fa-eye]="!typeInputPass" [class.fa-eye-slash]="typeInputPass"></i>
                            </button>
                        </div>
                        <div class="input-error" *ngIf="form.get('password').errors && form.get('password').dirty">
                            <i class="fas fa-exclamation-circle"></i>
                            <span *ngIf="form.get('password').errors['required']">Campo requerido</span>
                            <span *ngIf="form.get('password').hasError('minlength')">Mínimo {{passwordMinLength}}
                                caracteres</span>
                            <span *ngIf="form.get('password').hasError('maxlength')">Máximo {{passwordMaxLength}}
                                caracteres</span>
                        </div>

                        <!-- Forgot Password Link -->
                        <div style="text-align: right; margin-top: 0.5rem;">
                            <a href="javascript:void(0)" (click)="showPasswordRecovery = true"
                                style="color: #01abce; font-size: 0.875rem; text-decoration: none; cursor: pointer; transition: color 0.2s;"
                                onmouseover="this.style.color='#0194b3'" onmouseout="this.style.color='#01abce'">
                                ¿Olvidaste tu contraseña?
                            </a>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <button type="submit" [disabled]="!form.valid || submit_disabled" class="submit-button">
                        <span class="button-text">
                            <i class="fas fa-sign-in-alt" *ngIf="!submit_disabled"></i>
                            <i class="fas fa-spinner fa-spin" *ngIf="submit_disabled"></i>
                            {{submit_disabled ? 'Iniciando sesión...' : 'INICIAR SESIÓN'}}
                        </span>
                    </button>

                </form>

                <!-- Footer -->
                <div class="form-footer">
                    <div class="security-info">
                        <i class="fas fa-shield-alt"></i>
                        <span>Conexión segura SSL</span>
                    </div>
                </div>
            </div>

            <!-- Contenedor dinámico de pasos 2FA / Recuperación para evitar apilamiento -->

            <!-- Selector de Método 2FA -->
            <app-select-2fa-method *ngIf="showSelectMethod && !showVerify2FA && !showSetup2FA && !showPasswordRecovery"
                [tempToken]="tempToken" [availableMethods]="availableMethods" [configuredMethods]="configuredMethods"
                [phoneNumber]="phoneNumber" (onMethodSelected)="onMethodSelected($event)"
                (onSetupRequired)="onSetupRequired($event)" (onCancel)="onMethodSelectionCancelled()">
            </app-select-2fa-method>

            <!-- Componente de Verificación 2FA -->
            <app-verify-2fa-login *ngIf="showVerify2FA && !showSelectMethod && !showSetup2FA && !showPasswordRecovery"
                [tempToken]="tempToken" [twoFactorMethod]="twoFactorMethod" [phoneNumber]="phoneNumber"
                (onSuccess)="on2FAVerified($event)" (onCancel)="on2FACancelled()">
            </app-verify-2fa-login>

            <!-- Componente de Cuenta Bloqueada -->
            <app-account-locked *ngIf="showAccountLocked" [lockType]="lockType" [remainingTime]="remainingTime"
                [incident]="incident" [unlockAt]="unlockAt" (onClose)="onAccountLockedClose()">
            </app-account-locked>

            <!-- Componente de Setup 2FA (solo si no está en selector ni verificación) -->
            <app-setup-2fa-modal *ngIf="showSetup2FA && !showSelectMethod && !showVerify2FA && !showPasswordRecovery"
                [authToken]="tempToken" [preselectedMethod]="twoFactorMethod" (onComplete)="onSetup2FAComplete($event)"
                (onCancel)="onSetup2FASkip()">
            </app-setup-2fa-modal>

            <!-- Componente de Recuperación de Contraseña -->
            <app-password-recovery *ngIf="showPasswordRecovery && !showSelectMethod && !showVerify2FA && !showSetup2FA"
                (onCancel)="onPasswordRecoveryCancel()" (onSuccess)="onPasswordRecoverySuccess()">
            </app-password-recovery>

        </div>
    </div>
</div>

<!-- Modal: Sesión activa detectada -->
<div class="active-session-overlay" *ngIf="showActiveSessionDialog" (click)="onActiveSessionCancel()">
    <div class="active-session-dialog" (click)="$event.stopPropagation()">
        <div class="active-session-icon">
            <i class="fas fa-desktop" style="font-size: 1.5rem; color: #f59e0b;"></i>
        </div>
        <h3 class="active-session-title">Sesión activa detectada</h3>
        <p class="active-session-description">
            Ya existe una sesión iniciada con esta cuenta en otro dispositivo o navegador.
            ¿Deseas cerrar esa sesión e iniciar sesión aquí?
        </p>
        <div class="active-session-actions">
            <button class="btn-cancel" (click)="onActiveSessionCancel()">Cancelar</button>
            <button class="btn-force-login" (click)="onForceLogin()" [disabled]="submit_disabled">
                <i class="fas fa-spinner fa-spin" *ngIf="submit_disabled"></i>
                <span *ngIf="!submit_disabled">Cerrar otra sesión e iniciar aquí</span>
                <span *ngIf="submit_disabled">Procesando...</span>
            </button>
        </div>
    </div>
</div>